import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Col } from 'react-bootstrap';
import { checkConditions } from 'components/Common/HelperFunctions/checkConditions';
import { darkModeSelectStyles } from 'components/Common/CustomStyles/darkModeSelectStyles';

function FormSelect({ 
  conditions = [], 
  title = '', 
  required = false,
  menuHeight,
  options = [], 
  isClearable = true, 
  value,
  placeholder = 'Select...',
  isMulti = false,
  onChangeMethods = () => { return },
 }) {
  const darkMode = useSelector(state => state.app.darkMode);

  const conditionsMet = checkConditions(conditions);

  return (
    <>
      <Col className='mx-0 px-0'>
        {conditionsMet && 
          <div>
            <label>{`${title} ${required ? '*' : ''}`}</label>
            <Select
              data-intercom-target={`${title}-select`}
              options={options}
              required
              placeholder={placeholder}
              isClearable={isClearable}
              maxMenuHeight={menuHeight ?? 400}
              value={value ?? null}
              onChange={(e) => onChangeMethods?.(e)}
              styles={darkMode ? darkModeSelectStyles : ''}
              isMulti={isMulti}
            />
          </div>
        }
      </Col>
    </>
  )
}

export default FormSelect;
